/**
 * Custom hook for managing font loading state
 */
import { useEffect, useState } from 'react';
import { waitForFonts } from '../utils/optimizedFontLoading';

export const useFontLoader = (minDisplayTime = 0) => {
  const [fontsReady, setFontsReady] = useState(false);

  useEffect(() => {
    const start = performance.now();

    waitForFonts().then(() => {
      const elapsed = performance.now() - start;
      const delay = Math.max(0, minDisplayTime - elapsed);

      const timeoutId = setTimeout(() => setFontsReady(true), delay);
      return () => clearTimeout(timeoutId);
    });
  }, [minDisplayTime]);

  return fontsReady;
};
